const getConfigUrl = () => {
  const mode = import.meta.env.MODE;
  switch (mode){
    case 'development':
      return '/config/appsettings-dev.json'
    default:
    return '/config/appsettings.json'
  }
} 

async function fetchConfig() {
  const configPath = getConfigUrl()
  const resp = await fetch(configPath)
  const config = await resp.json()
  return config
}

export default fetchConfig
